// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"az_tu","spin":"az_uu","spinnerWrapper":"az_vu","spinner":"az_wu"};